import { AppShell } from '../components/AppShell'

const SERVICES = [
  { name: 'Trader API',         status: 'ok'       as const, detail: 'Avg. latency 87 ms' },
  { name: 'Sportsbook feed',    status: 'ok'       as const, detail: 'All sports streaming' },
  { name: 'Bet settlement',     status: 'ok'       as const, detail: 'Processing within 30 s of final whistle' },
  { name: 'Payouts',            status: 'degraded' as const, detail: 'Wise integration in mock mode' },
  { name: 'KYC verification',   status: 'ok'       as const, detail: 'Mock provider · instant decisions' },
  { name: 'Email delivery',     status: 'ok'       as const, detail: 'Postmark queue clean' },
]

const META: Record<'ok' | 'degraded' | 'down', { label: string; cls: string }> = {
  ok:       { label: 'Operational', cls: 'legal-status__row--ok'   },
  degraded: { label: 'Degraded',    cls: 'legal-status__row--warn' },
  down:     { label: 'Outage',      cls: 'legal-status__row--down' },
}

export function SystemStatusPage() {
  const allOk = SERVICES.every((s) => s.status === 'ok')
  return (
    <AppShell page="help" breadcrumb={<span className="topbar__breadcrumb-current">System Status</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Public · Live</span></p>
          <h1 className="page-header__title">System Status</h1>
          <p className="page-header__subtitle">
            {allOk ? 'All systems operational.' : 'One or more systems are degraded.'}
          </p>
        </div>
      </header>

      <ul className="legal-status">
        {SERVICES.map((s) => {
          const m = META[s.status]
          return (
            <li key={s.name} className={`legal-status__row ${m.cls}`}>
              <div className="legal-status__main">
                <span className="legal-status__name">{s.name}</span>
                <span className="legal-status__detail">{s.detail}</span>
              </div>
              <span className="legal-status__badge">{m.label}</span>
            </li>
          )
        })}
      </ul>
    </AppShell>
  )
}
